import { PlaybookStatus } from '@driftt/api-types'

import { HydratedPlaybookBlockData } from '.'

export const splitArchivedPlaybooks = (
  playbooks: HydratedPlaybookBlockData[]
) =>
  playbooks.reduce(
    (byStatus: Record<string, HydratedPlaybookBlockData[]>, playbook) => {
      if (playbook.playbookStatus === PlaybookStatus.ARCHIVED) {
        byStatus.archived.push(playbook)
      } else {
        byStatus.active.push(playbook)
      }

      return byStatus
    },
    { archived: [], active: [] }
  )
